// ** React Imports
import { Container } from '@chakra-ui/react'
import classnames from 'classnames'
// import { Fragment, useEffect } from 'react'

// ** Third Party Components

// ** Store & Actions
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
// import { handleContentWidth, handleMenuCollapsed, handleMenuHidden } from '../../../../redux/actions/layout'

// ** Styles
import { useMFAdminAppInitializer } from '../../../../contexts/MFAdminAppInitializer'
import 'animate.css/animate.css'

const LayoutWrapper = props => {
  // ** Props
  const { layout, children, appLayout, transition } = props

  // ** Store Vars
  // const dispatch = useDispatch()
  const store = useSelector(state => state)
  const navbarStore = store.navbar
  const contentWidth = store.layout.contentWidth

  const {
    state: {
      layout: { menu }
    }
  } = useMFAdminAppInitializer()

  const navWidth = useMemo(() => {
    if (menu.state === 'dock') return 4
    if (menu.state === 'full') return 14
    return 0
  }, [menu.state])

  const appMargin = useMemo(() => {
    if (menu.state === 'dock') return 16
    if (menu.state === 'full') return 56
    return 'auto'
  }, [menu.state])
  //** Vars
  // const Tag = layout === 'HorizontalLayout' && !appLayout ? 'div' : Fragment

  // ** Clean Up Function
  // const cleanUp = () => {
  //   if (routeMeta) {
  //     if (routeMeta.contentWidth) {
  //       dispatch(handleContentWidth('full'))
  //     }
  //     if (routeMeta.menuCollapsed) {
  //       dispatch(handleMenuCollapsed(!routeMeta.menuCollapsed))
  //     }
  //     if (routeMeta.menuHidden) {
  //       dispatch(handleMenuHidden(!routeMeta.menuHidden))
  //     }
  //   }
  // }

  // ** ComponentDidMount
  // useEffect(() => {
  //   if (routeMeta) {
  //     if (routeMeta.contentWidth) {
  //       dispatch(handleContentWidth(routeMeta.contentWidth))
  //     }
  //     if (routeMeta.menuCollapsed) {
  //       dispatch(handleMenuCollapsed(routeMeta.menuCollapsed))
  //     }
  //     if (routeMeta.menuHidden) {
  //       dispatch(handleMenuHidden(routeMeta.menuHidden))
  //     }
  //   }
  //   return () => cleanUp()
  // }, [])

  return (
    <Container
      maxW="100%"
      w={{ base: '100%', lg: `calc(100% - ${navWidth}rem)` }}
      ml={{ base: 'auto', lg: appMargin }}
      mr="auto"
      py={20}
      px={{ base: 4, md: 8 }}
      // className={classnames('app-content content', {
      //   // [wrapperClass]: wrapperClass,
      //   // 'show-overlay': navbarStore.query.length
      // })}
    >
      <div className="content-overlay"></div>
      <div className="header-navbar-shadow" />
      <div
        className={classnames({
          // 'content-wrapper': !appLayout,
          // 'content-area-wrapper': appLayout,
          'container p-0': contentWidth === 'boxed'
          // [`animate__animated animate__${transition}`]: transition !== 'none' && transition.length
        })}
      >
        <>{children}</>
      </div>
    </Container>
  )
}

export default LayoutWrapper
